// Демо-данные окна «Каталог виджетов» для главной Hub.
// requires — какой канал должен быть подключён, чтобы виджет заработал (null = работает сам по себе).
// greeting / chips — то, что видно в превью справа.

import { t } from "@/lib/i18n";

export const widgetCategories = [
  { id: "all", label: t("Все виджеты"), icon: "ri-apps-2-line" },
  { id: "messengers", label: t("Мессенджеры"), icon: "ri-chat-3-line" },
  { id: "social", label: t("Соцсети"), icon: "ri-heart-3-line" },
  { id: "email", label: t("Почта"), icon: "ri-mail-line" },
  { id: "universal", label: t("Универсальные"), icon: "ri-layout-grid-line" },
];

export const widgetCatalog = [
  {
    id: "multichannel",
    name: t("Мультиканальный виджет"),
    description: t("Клиент сам выбирает, куда писать: WhatsApp, Telegram или на почту — всё попадает в Hub."),
    category: "universal",
    icon: "ri-chat-smile-3-line",
    badge: t("Популярный"),
    requires: null,
    greeting: t("Здравствуйте! Куда вам удобнее написать?"),
    chips: ["WhatsApp", "Telegram", t("Почта")],
    extras: ["ri-whatsapp-line", "ri-telegram-line", "ri-mail-line"],
  },
  {
    id: "whatsapp",
    name: t("Виджет WhatsApp"),
    description: t("Кнопка на сайте открывает чат с номером компании в WhatsApp — без копирования номера."),
    category: "messengers",
    icon: "ri-whatsapp-line",
    requires: "whatsapp",
    greeting: t("Здравствуйте! Пишите в WhatsApp — ответим в течение 15 минут."),
    chips: [t("Узнать цену"), t("Доставка"), t("Гарантия")],
    extras: [],
  },
  {
    id: "telegram",
    name: t("Виджет Telegram"),
    description: t("Клиент попадает в бота компании одним нажатием и сразу видит историю переписки."),
    category: "messengers",
    icon: "ri-telegram-line",
    requires: "telegram",
    greeting: t("Здравствуйте! Открываю Telegram — бот уже ждёт ваш вопрос."),
    chips: [t("Оформить заказ"), t("Статус заказа"), t("Помощь")],
    extras: [],
  },
  {
    id: "facebook",
    name: t("Виджет Facebook"),
    description: t("Сообщения со страницы Facebook в том же окне, что и остальные диалоги."),
    category: "social",
    icon: "ri-facebook-circle-line",
    requires: "facebook",
    greeting: t("Здравствуйте! Напишите нам в Messenger — ответим от лица компании."),
    chips: [t("Написать в Messenger"), t("Каталог"), t("Доставка")],
    extras: [],
  },
  {
    id: "instagram",
    name: t("Виджет Instagram"),
    description: t("Диалоги из Direct прямо с сайта: клиенту не нужно искать аккаунт вручную."),
    category: "social",
    icon: "ri-instagram-line",
    requires: "instagram",
    greeting: t("Здравствуйте! Продолжим в Direct — там удобнее смотреть фото."),
    chips: [t("Написать в Direct"), t("Новинки"), t("Размеры")],
    extras: [],
  },
  {
    id: "tiktok",
    name: t("Виджет TikTok"),
    description: t("Сообщения из TikTok и заявки по видео — в общей ленте диалогов."),
    category: "social",
    icon: "ri-tiktok-line",
    badge: t("Новое"),
    requires: "tiktok",
    greeting: t("Здравствуйте! Отвечаем в TikTok — пришлём ссылку на товар из видео."),
    chips: [t("Товар из видео"), t("Наличие"), t("Цена")],
    extras: [],
  },
  {
    id: "viber",
    name: t("Виджет Viber"),
    description: t("Официальный аккаунт Viber с рассылками и поддержкой клиентов."),
    category: "messengers",
    icon: "ri-phone-fill",
    requires: "viber",
    greeting: t("Здравствуйте! Продолжим в Viber — там же придут уведомления о заказе."),
    chips: [t("Написать в Viber"), t("Заказ"), t("Оплата")],
    extras: [],
  },
  {
    id: "line",
    name: t("Виджет LINE"),
    description: t("Кнопка LINE Messenger для клиентов из Азии и международных команд."),
    category: "messengers",
    icon: "ri-message-3-line",
    requires: "line",
    greeting: "Hello! Continue in LINE — we reply within 10 minutes.",
    chips: ["Chat in LINE", "Pricing", "Support"],
    extras: [],
  },
  {
    id: "email",
    name: t("Виджет почты"),
    description: t("Форма «напишите нам» превращает письмо в диалог с историей и вложениями."),
    category: "email",
    icon: "ri-mail-line",
    requires: "email",
    greeting: t("Оставьте почту — ответим письмом и продолжим диалог в Hub."),
    chips: [t("Оставить почту"), t("Прайс-лист"), t("Договор")],
    extras: [],
  },
  {
    id: "callback",
    name: t("Обратный звонок"),
    description: t("Клиент оставляет номер — звонок падает в ленту с записью разговора."),
    category: "universal",
    icon: "ri-phone-line",
    badge: t("Быстрый старт"),
    requires: "telephony",
    greeting: t("Оставьте номер — перезвоним в течение рабочего дня."),
    chips: [t("Перезвоните мне"), t("Удобное время"), t("Отдел продаж")],
    extras: [],
  },
  {
    id: "lead",
    name: t("Виджет заявки"),
    description: t("Короткая форма с именем и задачей — заявка сразу становится диалогом."),
    category: "universal",
    icon: "ri-file-list-3-line",
    requires: null,
    greeting: t("Расскажите задачу — подберём решение и ответим в рабочее время."),
    chips: [t("Оставить заявку"), t("Нужна консультация"), t("Смета")],
    extras: [],
  },
];